module.exports = __webpack_public_path__ + "static/media/nvg-brand-bar-gradient.d5ac358d.png";